<script>
import Vue from 'vue'

/**
 * TransitionExpand Component
 * @class TransitionExpand
 */
export default Vue.extend({
  name: `TransitionExpand`,
  functional: true,

  render (createElement, context) {
    const data = {
      props: {
        name: `expand`
      },
      on: {
        afterEnter (element) {
          element.style.height = `auto`
        },

        enter (element) {
          const { width } = getComputedStyle(element)
          element.style.width = width
          element.style.position = `absolute`
          element.style.visibility = `hidden`
          element.style.height = `auto`

          const { height } = getComputedStyle(element)
          element.style.width = ''
          element.style.position = ''
          element.style.visibility = ''
          element.style.height = '0'
          setTimeout(() => {
            element.style.height = height
          })
        },

        leave (element) {
          const { height } = getComputedStyle(element)
          element.style.height = height
          setTimeout(() => {
            element.style.height = '0'
          })
        }
      }
    }
    return createElement(`transition`, data, context.children)
  }
})
</script>

<style>
.expand-enter-active,
.expand-leave-active {
  transition: height .25s ease-in-out;
  overflow: hidden;
}
.expand-enter,
.expand-leave-to {
  height: 0;
}
</style>
